/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBearLeft2 = createReactComponent("arrow-bear-left-2", "IconArrowBearLeft2", [
  ["path", { d: "M9 3h-5v5", key: "svg-0" }],
  ["path", { d: "M4 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93", key: "svg-1" }],
  ["path", { d: "M20 5l-4.5 4.5", key: "svg-2" }]
]);

export { IconArrowBearLeft2 as default };
//# sourceMappingURL=IconArrowBearLeft2.js.map
